import React, {useState} from "react";
import {useNominalCodesData} from "../../../hooks/useNominalCodesData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getNominalCodesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import { Box, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import NominalCodeRow from "./NominalCodeRow";
import {createSetDataFreshAction, createSetNominalCodesDataAction} from "../../../actions/dataActions";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import NewNominalCode from "./NewNominalCode";
import {formatXeroData, sendXeroData} from "../../../utils";
import PaginationWrapper from "../../Utils/PaginationWrapper";



export default function NominalCodeView(props){
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);
    let loading = useNominalCodesData({page}, dataFresh);
    const data = useSelector(getNominalCodesData);


    const onChange = (e, index) => {
        let newCodes = {...data};
        newCodes.results[index][e.target.name] = e.target.value;
        dispatch(createSetNominalCodesDataAction(newCodes));
    };

    const validator = data => {
        if(data.code){
            return true;
        }
        return false;
    };

    const onSave = data => {
        if(validator(data)){
            let url = data.id ? "nominal/"+data.id : "nominal";
            const conf = {
                url: props.endpoint+url,
                method: data.id ? "put" : "post",
                data: data
            }
            axios(conf).then(res => {
                dispatch(createSetDataFreshAction(dataFresh+1));
                let code = formatXeroData(res.data, "NC");
                console.log(code);
                sendXeroData(code, "XeroNominal").then(res => {
                    toast.success("All Data has been sent to xero sucessfully", {position: "top-right"});
                }).catch(err => {
                    console.log(err);
                    toast.error("There was an error sending data to Xero", {position: "top-right"});
                })
            }).catch(err => {
                toast.error("There was an error saving nominal code", {position: "top-right"});
            })
        }
        else{
            toast.warning("Code Required", {position: "top-right"});
        }
    };

    const onDelete = (data) => {
        const conf = {
            url: props.endpoint + "nominal/" + data.id,
            method: "delete"
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1))
        }).catch(err => {
           toast.error("Error when deleting nominal code", {position: "top-right"});
        })
    };


    if(!loading){
        return (
            <LoadingSpinner/>
        )
    }



    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <br/>
            <NewNominalCode onSave={onSave}/>
            <Box>
                <details>
                    <summary><Title>Nominal Code</Title></summary>/
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Type</th>
                                        <th>Tax Type</th>
                                        <th>Bank Account Number</th>
                                        <th>Description</th>
                                        <th>Enable Payments to Account</th>
                                        <th>Show in Expense Claims</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((data, index) => (
                                    <NominalCodeRow
                                        code={data}
                                        onSave={onSave}
                                        onDelete={onDelete}
                                        onChange={onChange}
                                        index={index}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <PaginationWrapper
                        setPage={setPage}
                        page={page}
                        dataCount={Math.ceil(data.count / 25)}
                    />
                </details>
            </Box>
        </div>
    );



}